<template>
	<page>
		<module enable-flex :tabs="tabs" @tabChange="tabHandle">
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="类型" style="width:180px;" v-if="userInfo.platform_user_id!=0 && userInfo.stationed_type == 2">
					<c-checkbox-group name="types" :options="productTypeData"></c-checkbox-group>
				</m-search-item>
                <m-search-item label="服务ID">
                    <c-input name="product_id" type="number" decimal="0" :limit="[1,999999999]" placeholder="精确匹配"></c-input>
                </m-search-item>
                <m-search-item label="服务标题">
                    <c-input name="product_name" placeholder="模糊匹配"></c-input>
                </m-search-item>
				<m-search-item label="商品类目">
				  <c-select name="product_type_id" options="PRODUCT_CLASSIFY"></c-select>
				</m-search-item>
                <!-- <m-search-item label="SKU编码">
                    <c-input name="product_sku_code" placeholder="精确匹配"></c-input>
                </m-search-item> -->
                <m-search-item label="缺货订购" v-if="systemConfig.is_outstock == 'ON'">
                    <c-checkbox-group name="outstocks" :options="isOutstockData"></c-checkbox-group>
                </m-search-item>
                <m-search-item label="定制" v-if="systemConfig.product_custom == 'ON'">
                    <c-checkbox-group name="customs" :options="isCustomData"></c-checkbox-group>
                </m-search-item>
                 <m-search-item label="价格模式" >
                    <c-select name="price_modue" :options="priceModueOptions"></c-select>
                </m-search-item>
                <!-- <m-search-item label="服务类型" >
                    <c-select name="is_virtual" :options="isVirtualOptions"></c-select>
                </m-search-item>
                <m-search-item label="所属分类" v-if="this.is_open_shop == 2">
					<c-select name="group_id" options="PRODUCT_GROUP"></c-select>
				</m-search-item> -->
				<!-- <m-search-item label="发货地">
					<c-input type="hidden" name="delivery_address_id"></c-input>
					<c-input name="delivery_address_name" readonly @focus="$refs.deliveryAddressSelectorSearch.open()"></c-input>
				</m-search-item> -->
				<m-search-item label="创建时间" colspan="2">
					<c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
				</m-search-item>
<!--				<m-search-item label="SKU编码">
					<c-input name="product_sku_code"></c-input>
				</m-search-item>-->
			</m-search>
			
			<m-operate>
				<c-button v-if="auth('b_product_edit')" color="main" @click="selectClassify">发布服务</c-button>
                <c-button v-if="auth('b_product_edit') && this.currentTab.value != 2" @click="editProductType()">更换类目</c-button>
                <c-button v-if="userInfo.platform_user_id!=0 &&  auth('b_product_platform_to_seller')" @click="selectPlatformProduct">选货分销</c-button>
                <!--
				<c-button v-if="auth('b_product_group_set') && this.is_open_shop == 2" @click="editType()">批量归属分类</c-button>
				<c-button v-if="auth('b_product_delivery_set')" @click="setDeliveryAddresss(null)">批量发货地设置</c-button>
				-->
                <c-button v-if="auth('b_product_sold') && (this.currentTab.value == '' || this.currentTab.value == 1)" @click="soldHandle('in')">批量上架</c-button>
				<c-button v-if="auth('b_product_sold') && (this.currentTab.value == '' || this.currentTab.value == 2)" @click="soldHandle('out')">批量下架</c-button>
			</m-operate>

			<c-table ref="table" height="grow">
				<c-table-column
					type="selector"
				></c-table-column>

				<c-table-column
					label="服务ID"
					width="70"
					name="product_id"
				></c-table-column>

				<c-table-column
					label="状态"
					width="80"
					name="state"
				>
					<template #default="{data}">
						<p v-if="stateData[data.state]" :style="{'color': stateData[data.state].color}">{{stateData[data.state].name}}
                            <c-tooltip v-if="data.state==4" :tip="data.reject_reason" style="margin-left: 3px;"></c-tooltip>
                        </p>

					</template>
				</c-table-column>

				<c-table-column
					label="类型"
					width="60"
					name="platfrom_product_id"
					v-if="userInfo.platform_user_id!=0 && userInfo.stationed_type == 2"
				>
					<template #default="{data}">
						<span v-if="data.platfrom_product_id" style="color:blue">分销</span>
						<span v-else style="color:#999">自建</span>
					</template>
				</c-table-column>

				<c-table-column
					label="服务信息"
					width="300"
				>
                    <template #default="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
				</c-table-column>

				<c-table-column
				        label="可售区域"
				        width="400"
				        name="region_names"
				>
				    <template #default="{data}">
				        <span v-if="data.region_type == 1" style="color:green">全国可售</span>
				        <span v-if="data.region_type == 2">{{data.region_names}}</span>
						<span v-if="data.region_type == 3">全国可售，以下地区除外（<span style="color:red">{{data.region_names}}</span>）</span>
				    </template>
				</c-table-column>

				<c-table-column
					label="同步状态"
					width="140"
					name="platfrom_product_id"
					v-if="userInfo.platform_user_id!=0 && userInfo.stationed_type == 2"
				>
					<template #default="{data}">
						<span v-if="data.platfrom_product_id && data.is_auto_sync==1">
							<p style="color:green">自动同步</p>
							<p>{{data.last_sync_date}}</p>
						</span>
						<span v-else-if="data.platfrom_product_id && data.is_auto_sync==0">
							<p style="color:burlywood">手动同步</p>
							<p>{{data.last_sync_date}}</p>
						</span>
						<span v-else style="color:#999">--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="定制"
					width="60"
					name="is_custom"
					v-if="systemConfig.product_custom == 'ON'"
				>
					<template #default="{data}">
						<span v-if="data.is_custom == 1" style="color:blue">支持</span>
						<span v-else style="color:#999">不支持</span>
					</template>
				</c-table-column>

				<c-table-column
					label="缺货订购"
					width="90"
					name="is_outstock"
					v-if="systemConfig.product_custom == 'ON'"
				>
					<template #default="{data}">
						<span v-if="data.is_outstock == 2" style="color:blue">支持</span>
						<span v-else style="color:#999">不支持</span>
					</template>
				</c-table-column>

				<c-table-column
					label="所属类目"
					width="240"
					name="product_type_full_name"
				>
                    <template v-slot="{data}">
                        <span v-if="systemConfig.is_virtual_product == 'ON' && data.is_virtual == 0">[实物]</span>
                        <span v-if="systemConfig.is_virtual_product == 'ON' && data.is_virtual == 1" style="color:blue">[虚拟]</span>
                        {{data.product_type_full_name}}
                    </template>
                </c-table-column>

				<!-- <c-table-column
					label="所属分类"
					width="250"
					name="product_group_full_name"
                    v-if="this.is_open_shop == 2"
				></c-table-column> -->

				<c-table-column
				        label="价格模式"
				        width="85"
				>
				    <template #default="{data}">
				        <span v-if="data.price_modue == 1">预设售价</span>
				        <span v-else style="color: blue">价格面议</span>
				    </template>
				</c-table-column>

				<c-table-column
					label="价格(元)"
					width="120"
					name="product_cost_price"
				>
					<template #default="{data}">
						<c-link v-if="data.price_modue == 1 && auth('b_product_edit') && data.platfrom_product_id" @click="setPrice(data)">{{data.product_cost_price}}<i class="tf-edit"></i></c-link>
						<span v-else-if="data.price_modue == 1 && data.product_cost_price">￥{{parseFloat(data.product_cost_price)}}</span>
                        <span v-else>-</span>
                        <p v-if="userInfo.platform_user_id!=0 && userInfo.stationed_type == 2
                            && data.platform_product_cost_price
                            && data.platform_product_cost_price > data.product_cost_price" style="color: red">
                            供货价:￥{{parseFloat(data.platform_product_cost_price)}}
                        </p>
					</template>
				</c-table-column>

				<c-table-column
					label="价格单位"
					name="price_unit"
					width="80"
				>
					<template v-slot="{data}">
						{{data.price_unit || '-'}}
					</template>
				</c-table-column>

				<c-table-column
					label="库存"
					width="100"
				>
					<template #default="{data}">
						<c-link v-if="auth('b_product_stock')" @click="setStock(data)">{{data.stock_count}}<i class="tf-edit"></i></c-link>
						<span v-else>{{data.stock_count}}</span>
					</template>
				</c-table-column>

				<!-- <c-table-column
					label="销量"
					width="80"
					name="sale_count"
				></c-table-column> -->

				<!-- <c-table-column
					label="发货地"
					width="90"
					name="product_delivery_address_name"
				></c-table-column> -->

				<c-table-column
					label="创建时间"
					width="150"
				>
					<template v-slot="{data}">
						<p>{{data.create_date}}</p>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="170"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_product_edit') && !data.platfrom_product_id" @click="navigateTo(`/product_edit/${data.product_id}`)">编辑</c-table-button>
						<c-table-button v-if="data.platfrom_product_id" @click="navigateTo(`/product_detail/${data.product_id}`)">查看</c-table-button>
						<!-- <c-table-button v-if="auth('b_product_group_set') && is_open_shop == 2" @click="editType(data)">归属分类</c-table-button> -->
						<!-- <c-table-button v-if="auth('b_product_delivery_set')" @click="setDeliveryAddresss(data)">设置发货地</c-table-button> -->
						<c-table-button v-if="auth('b_product_sold') && data.state == 1" @click="soldHandle('in', data)">上架</c-table-button>
						<c-table-button v-if="auth('b_product_sold') && data.state == 2" @click="soldHandle('out', data)">下架</c-table-button>
						<!-- <c-table-button v-if="auth('b_product_preview') && data.state == 2" @click="previewHandle(data)">预览</c-table-button> -->
                        <c-table-button v-if="auth('b_product_edit') && (data.state == 0 || data.state == 1 || data.state == 3 || data.state == 4)" @click="delHandle(data)">删除</c-table-button>
                        <c-table-button v-if="auth('b_product_platform_sync') && data.platfrom_product_id && data.is_auto_sync == 0" @click="configAutoSync(data)">开启自动同步</c-table-button>
                        <c-table-button v-if="auth('b_product_platform_sync') && data.platfrom_product_id && data.is_auto_sync == 1" @click="configAutoSync(data)">关闭自动同步</c-table-button>
                        <c-table-button v-if="auth('b_product_platform_sync') && data.platfrom_product_id && data.is_auto_sync == 0" @click="syncProductData(data)">同步数据</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="classifySelector" title="选择服务类目" width="750" @resolve="createProduct" @close="getClassify(0)">
			<div class="classify-select flex-center">
				<dl v-for="(level, i) in productClassify" :key="i">
					<dt>
						<i class="tf tf-search"></i>
						<input v-model="classifySearch[i]" type="text" @keyup.enter="getClassify(i)">
					</dt>
					<dd>
						<ul>
							<li v-for="(item, j) in level" :key="j" class="flex-between-center" :class="{'z-crt': item == currentClassify[i]}" @click="classifyHandle(item, i)">
								<span>{{item.type_name}}</span>
								<i v-show="item.is_parent > 0" class="tf tf-angle-right"></i>
							</li>
						</ul>
					</dd>
				</dl>
			</div>
		</c-dialog>
		<c-dialog ref="changeProductClassify" title="变更服务类目" width="750" @resolve="handleProductTypeEdit" @close="getClassify(0)">
			<div class="classify-select flex-center">
				<dl v-for="(level, i) in productClassify" :key="i">
					<dt>
						<i class="tf tf-search"></i>
						<input v-model="classifySearch[i]" type="text" @keyup.enter="getClassify(i)">
					</dt>
					<dd>
						<ul>
							<li v-for="(item, j) in level" :key="j" class="flex-between-center" :class="{'z-crt': item == currentClassify[i]}" @click="classifyHandle(item, i)">
								<span>{{item.type_name}}</span>
								<i v-show="item.is_parent > 0" class="tf tf-angle-right"></i>
							</li>
						</ul>
					</dd>
				</dl>
			</div>
		</c-dialog>

		<c-dialog ref="priceEdit" title="价格设置" width="1000" height="600"  @resolve="setPriceHandle">
			<c-title>规格信息</c-title>
			<c-table ref="priceTable" height="auto" :paging="false">
				<c-table-column
					label="规格名称"
					name="product_sku_spec"
					width="220"
				></c-table-column>
				
				<c-table-column
					label="参考供货价"
					name="supply_product_price"
					width="70"
				>
					<template v-slot="{data}">
						{{parseFloat(data.supply_product_price).toFixed(2)}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="当前售价"
					name="old_product_price_cost"
					width="70"
				>
					<template v-slot="{data}">
						{{parseFloat(data.old_product_price_cost).toFixed(2)}}
					</template>
				</c-table-column>
				
				<c-table-column
					width="80"
				>
					<template slot="head">
						<div class="flex-center-cross">
							<span>新售价</span>
							<a style="margin-left: 5px;" @click="$refs.batchPriceDialog.open()"><i class="tf tf-edit"></i></a>
						</div>
					</template>
					<template v-slot="{data}">
						<c-input v-model="data.product_price_cost" type="number" decimal="2" :range="[0.01, 99999]"></c-input>
					</template>
				</c-table-column>
				
				<c-table-column
					label="加价比例"
					width="60"
				>
					<template v-slot="{data}">
						{{((parseFloat(data.product_price_cost)/parseFloat(data.supply_product_price)-1)*100).toFixed(2)}}%
					</template>
				</c-table-column>
			</c-table>
			
			<c-title title="定制信息" v-show="isCustom == 1">规格信息</c-title>
			<c-table ref="customTable" v-show="isCustom == 1" height="auto" :paging="false">
				<c-table-column
					label="定制项"
					name="item_name"
					width="200"
				>
				  <template v-slot="{data}">
					{{data.item_name}}{{data.param_value ? '【' + data.param_value + '】' : ''}}
				  </template>
				</c-table-column>
			
				<c-table-column
					label="定制位置"
					name="position_name"
					width="150"
				>
				  <template v-slot="{data}">
					<div v-if="data.position_name" class="flex-center-cross">
					  <c-file media :src="data.position_image_url" style="width:42px;height:42px;margin-right: 10px;"></c-file>
					  <span>{{data.position_name}}</span>
					</div>
				  </template>
				</c-table-column>
			
				<c-table-column
					label="工艺名称"
					name="tech_name"
					width="80"
				></c-table-column>
			
				<c-table-column
					label="起定量"
					name="min_custom_count"
					width="60"
				></c-table-column>
			
				<c-table-column
					label="参考供货价"
					name="supply_product_price"
					width="80"
				>
				  <template v-slot="{data}">
					￥{{parseFloat(data.supply_product_price).toFixed(2)}}
				  </template>
				</c-table-column>
			
				<c-table-column
					label="当前定制价"
					name="product_price"
					width="80"
				>
				  <template v-slot="{data}">
					￥{{data.product_price}}
				  </template>
				</c-table-column>
			
				<c-table-column
					width="80"
				>
					<template slot="head">
						<div class="flex-center-cross">
							<span>新定制价</span>
							<a style="margin-left: 5px;" @click="$refs.batchCustomPriceDialog.open()"><i class="tf tf-edit"></i></a>
						</div>
					</template>
					<template v-slot="{data}">
						<c-input v-model="data.product_price_cost" type="number" decimal="2" :range="[0.01, 99999]"></c-input>
					</template>
				</c-table-column>
				
				<c-table-column
					label="加价比例"
					width="60"
				>
					<template v-slot="{data}">
						{{((parseFloat(data.product_price_cost)/parseFloat(data.supply_product_price)-1)*100).toFixed(2)}}%
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>
		
		<c-dialog ref="stockEdit" title="库存设置" width="800" @resolve="setStockHandle">
			<c-table ref="stockTable" height="400" :paging="false">
				<c-table-column
					label="规格名称"
					name="product_sku_spec"
					width="220"
				></c-table-column>
				
				<c-table-column
					label="当前实际库存"
					name="product_sku_stock"
					width="100"
				></c-table-column>
				
				<c-table-column
					label="订单已占用"
					name="product_order_occupy_count"
					width="90"
				></c-table-column>
				
				<c-table-column
					label="可用库存"
					width="80"
				>
					<template v-slot="{data}">
						<b>{{data.product_sku_stock - data.product_order_occupy_count}}</b>
					</template>
				</c-table-column>
				
				<c-table-column
					width="100"
				>
					<template slot="head">
						<div class="flex-center-cross">
							<span>增减库存</span>
							<a style="margin-left: 5px;" @click="$refs.batchStockDialog.open()"><i class="tf tf-edit"></i></a>
						</div>
					</template>
					<template v-slot="{data}">
						<c-input v-model="data.revise_stock" type="number" :range="[-data.product_sku_stock, 9999]"></c-input>
					</template>
				</c-table-column>
				
				<c-table-column
					label="调整后可用库存"
					name="product_sku_stock"
					width="110"
				>
					<template v-slot="{data}">
						<b style="color:green">{{parseInt(data.product_sku_stock) - parseInt(data.product_order_occupy_count)  + (parseInt(data.revise_stock) || 0)}}</b>
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>
		
		<product-type-edit ref="productTypeEdit" @resolve="submitTypeEdit"></product-type-edit>
		<delivery-address-selector ref="deliveryAddressSelector" multiple @resolve="submitDeliveryAddressConfig"></delivery-address-selector>
		<delivery-address-selector ref="deliveryAddressSelectorSearch" @resolve="selectDeliveryAddress"></delivery-address-selector>
		<platform-product-selector ref="platformProductSelector" multiple @resolve="copyPlatformProduct"></platform-product-selector>
		
		<!--单服务多SKU-->
		<c-dialog ref="batchPriceDialog" title="批量设置售价" width="400" height="140" @resolve="batchSetPrice">
		    <c-form ref="batchPriceForm">
				<c-form-item label="新售价">
					<c-input type="number" name="value" range="0,999" decimal="2"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
		
		<!--单服务多SKU-->
		<c-dialog ref="batchCustomPriceDialog" title="批量设置售价" width="400" height="140" @resolve="batchSetCustomPrice">
		    <c-form ref="batchCustomPriceForm">
				<c-form-item label="新售价">
					<c-input type="number" name="value" range="0,999" decimal="2"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
		
		<c-dialog ref="batchStockDialog" title="批量增减库存" width="400" height="140" @resolve="batchSetStock">
		    <c-form ref="batchStockForm">
				<c-form-item label="增减库存">
					<c-input type="number" name="value"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
		
		<c-dialog ref="batchAddProductDialog" title="设置商城加价比例" width="340" height="220">
		    <c-form ref="batchAddProductForm" vertical>
				<c-form-item label="服务加价比例">
					<c-input type="number" name="add_product_ratio" range="0,999" decimal="0" append-text="%"></c-input>
				</c-form-item>
				<!--
				<c-form-item label="定制加价金额(单项)" >
					<c-input type="number" name="add_custom_money" range="0,999" decimal="2" append-text="元"></c-input>
				</c-form-item>
				-->
			</c-form>
			<template #button>
				<c-button @click="batchAddProduct(2)" color="main">确定并上架</c-button>
				<c-button @click="batchAddProduct(1)" color="main">确定</c-button>
				<c-button @click="$refs.batchAddProductDialog.close()">取消</c-button>
			</template>
		</c-dialog>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import productInfo from '@/components/public/product_info.vue'
	import deliveryAddressSelector from '@/components/service/delivery_address_selector.vue'  // 发货地
	import deliveryAddressSelectorSearch from '@/components/service/delivery_address_selector.vue'  // 发货地搜索
	import platformProductSelector from '@/components/service/platform_product_selector.vue'  // 平台服务库
	
	export default {
		components: {
			productInfo,
			deliveryAddressSelector,
			deliveryAddressSelectorSearch,
			platformProductSelector
		},
		
		props: {
			tab: String
		},
		
		data() {
			return {
				tabsData: [{
					name: '全部服务',
					value: ''
				}, {
					name: '出售中',
					value: '2',
					color:'green'
				}, {
					name: '已下架',
					value: '1',
					color: '#999'
				}, {
					name: '审核中',
					value: '3',
					color: '#0060EF'
				}, {
					name: '已驳回',
					value: '4',
					color: '#FF4444'
				}, {
					name: '草稿箱',
					value: '0',
					color: '#FF4444'
				}],
				productTypeData: [{
					name: '自建',
					value: '1'
				}, {
					name: '分销',
					value: '2',
				}],
                isCustomData: [
                    {name: '支持',value: '1'},
                    {name: '不支持',value: '0'}
                ],
                isOutstockData: [
                    {name: '支持',value: '2'},
                    {name: '不支持',value: '1'}
                ],
				tabsTotal: [],
				currentTab: {},
				
				productClassify: [
					[], []
				],
				currentClassify: [],
				classifySearch: [],
				currentClassifyId: '',
                currentClassifyIsVirtual:'',
				platformProductData: {},
				isCustom: 1,
                isVirtualOptions: [
                    {name: '实物服务',value: 0},
                    {name: '虚拟服务',value: 1}
                ],
                priceModueOptions: [
                    {name: '预设价格',value: 1},
                    {name: '价格面议',value: 2}
                ],
                is_open_shop:1, //是否开通店铺（1：不开通店铺，2：开通店铺）
                editProductTypeIds:[]//变更服务类目的服务ID集合
            }
		},
		
		computed: {
			...mapState(['userInfo','systemConfig']),
			
			tabs() {
				return Array.from(this.tabsData, (item, index) => {
					return Object.assign({}, item, {
						name: this.tabsTotal[index] > 0 ? `${item.name}(${this.tabsTotal[index]})` : item.name
					});
				});
			},
			
			stateData() {
				let data = {};
				this.tabsData.forEach(item => {
					data[item.value] = item;
				});
				return data;
			}
		},
		
		mounted() {
            this.initShopInfo();
			this.$emitBus('fromProductApply', this.selectClassify);
			this.$onBus('productApply', () => {
				this.selectClassify();
			});
			this.updateTotal();
		},
		
		beforeDestroy() {
			this.$offBus('productApply');
		},
		
		methods: {
            //查询商家信息
			initShopInfo() {
                this.request({
                    url: '/stationed/shop/info',
                    data: {},
                    loading: false,
                    success: data => {
                        this.is_open_shop = data.is_open_shop || 1;
                    }
                });
			},
			tabHandle(item) {
				this.currentTab = item;
				this.$refs.search.search();
			},

			updateTotal() {
				this.request({
					url: '/product/state/count_list',
					success: data => {
						this.tabsTotal = data;
					}
				});
			},
			
			searchHandle(data) {
				//刷新服务各个状态数量
				this.updateTotal();
				this.$refs.table.load({
					url: '/product/list',
					data: Object.assign(data, {
						state: this.currentTab.value ? [this.currentTab.value] : []
					})
				});
			},
			
			selectClassify() {
				if (!this.productClassify[0].length) {
					this.getClassify(0, 0);
				}
				this.$refs.classifySelector.open();
			},
			
			classifyHandle(item, level) {
				this.currentClassifyId = item.id;
                this.currentClassifyIsVirtual = item.is_virtual;
                this.$set(this.currentClassify, level, item);
				this.select_level = level;
				if (level < 1) {
					this.getClassify(level+1, !item.is_parent);
				}
			},
			
			getClassify(level, empty) {
				new Promise(resolve => {
					if (empty) {
						resolve([]);
					} else {
						this.request({
							url: '/product_type/common_list',
							data: {
								type_name: this.classifySearch[level],
								parent_id: level ? this.currentClassify[level-1].id : 0
							},
							success: data => {
								if (!data) {
									this.$message({
										message: '未找到分类'
									});
									return;
								}
								
								resolve(data);
							}
						});
					}
				}).then(data => {
					this.$set(this.productClassify, level, data);
					for (let i=level; i<2; i++) {
						i > level && this.$set(this.productClassify, i, []);
						this.$set(this.currentClassify, i, undefined);
					}
					this.currentClassifyId = level ? this.currentClassify[level-1].id : '';
                    this.currentClassifyIsVirtual = level ? this.currentClassify[level-1].is_virtual : '';
                });
				// this.$set(this.classifySearch, level, '');
			},
            /**
             * 发布商品
             * @param stop
             */
			createProduct(stop) {
				if (!this.currentClassifyId) {
					stop();
					this.$message({
						message: '请选择类目'
					});
					return;
				}
				
				if(this.select_level != 1){
					stop();
					this.$message({
						message: '请选择二级类目'
					});
					return;
				}
				
				var name = [];
				this.currentClassify.forEach(item => {
					item && name.push(item.type_name);
				});
				this.navigateTo({
					path: '/product_apply',
					query: {
						classify: this.currentClassifyId,
                        classifyName: name.join(',')
					}
				});
			},
            /**
             * 服务类目变更响应方法
             * @param item
             */
			handleProductTypeEdit(stop) {
				if (!this.currentClassifyId) {
					stop();
					this.$message({
						message: '请选择类目'
					});
					return;
				}

				if(this.select_level != 1){
					stop();
					this.$message({
						message: '请选择二级类目'
					});
					return;
				}
                var name = [];
                this.currentClassify.forEach(item => {
                    item && name.push(item.type_name);
                });
                this.$confirm({
                    message: '是否确定将当前选中的【'+this.editProductTypeIds.length+'】款服务，全部切换至【'+name.join('=>')+'】类目下？切换后，服务中的非自定义“所需材料”将全部被清除，请谨慎操作',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/product/type/edit',
                            data: {
                                product_type_id:this.currentClassifyId,
                                product_ids:this.editProductTypeIds
                            },
                            loading: true,
                            success: data => {
                                this.$refs.table.update();
                                this.$message({
                                    message: '操作成功',
                                    icon: 'success'  // 图标（success：成功，fail：失败）
                                });
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
			},
            /**
             * 服务类目方法
             * @param item
             */
            editProductType() {
                var list = this.$refs.table.getRow('selected');
                var flag = true;
                list.forEach(function(item, index, array) {
                    if(item.data.state == 2){
                        flag = false;
                    }
                });

                if(!flag){
                    this.$message({
                        message: '“出售中”的服务不允许编辑服务类目，请先下架服务！',
                        type: 'warn'
                    });
                    return false;
                }
                this.editProductTypeIds = Array.from(list,item=>{
                    return item.data.product_id;
                })
                if (!this.editProductTypeIds || this.editProductTypeIds.length == 0){
                    this.$message({
                        message: '请选择需要编辑类目的服务',
                        type: 'warn'
                    });
                    return;
                }
                if (!this.productClassify[0].length) {
                    this.getClassify(0, 0);
                }
                this.$refs.changeProductClassify.open();
			},

			//设置服务分类回调
			submitTypeEdit(){
				this.$refs.table.update();
			},
			//发货地设置
			setDeliveryAddresss(data) {
				this.tagProductIds = [];
				//批量操作
				if(data == null){
					var list = this.$refs.table.getRow('selected');
					if (!list.length) {
						this.$message({
							message: '请选择要设置的服务'
						});
						return;
					}
					
					this.tagProductIds = Array.from(list,item=>{
					        return item.data.product_id;
					    })
				}else{
					this.tagProductIds.push(data.product_id);
				}
				this._deliveryAddressConfig = this.tagProductIds;
				this.$refs.deliveryAddressSelector.open(data?data.product_id:0);
			},
			
			submitDeliveryAddressConfig(data) {
				this.request({
					url: '/product/set_product_delivery_addresss',
					data: {
			            product_ids: this._deliveryAddressConfig,
						delivery_address_ids: Array.from(data, item => {
							return item.id
						})
					},
					loading: true,
					success: () => {
						this.$refs.table.update();
					}
				});
			},
			selectDeliveryAddress(data) {
				this.$refs.search.set({
					delivery_address_id: data[0].id,
					delivery_address_name: data[0].delivery_province_name+" "+data[0].delivery_city_name
				});
			},
			soldHandle(type, item) {
				var list = item ? [{
					data: item
				}] : this.$refs.table.getRow('selected');
				if (!list.length) {
					this.$message({
						type: 'success',
						message: '请选择要操作的服务'
					});
					return;
				}
				
				for(let item of list) {
					console.log(item);
					if(item.data.state !=1 && item.data.state !=2){
						this.$message({
							type: 'warn',
							message: "存在不能批量操作状态（审核中/驳回/草稿）的服务！"
						});
						return;
					}
				}

				this.$confirm({
					message: `确定要${type == 'in' ? '上架' : '下架'}${item ? '该' : '所选'}服务吗？`,
					resolve: () => {
						this.request({
							url: '/product/sold',
							data: {
								type: type == 'in' ? 1 : 2,
								product_ids: Array.from(list, item => item.data.product_id)
							},
							loading: true,
							success: () => {
								this.$message({
									message: '操作成功',
									type: 'success'
								});
								this.$refs.table.update();
								this.updateTotal();
							}
						});
					}
				});
			},

			delHandle(params) {
				this.$confirm({
					message: '确定要删除服务【'+params.product_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/product/del',
							data: {
								product_id: params.product_id
							},
							loading: true,
							success: data => {
								this.$message({
									message: '服务已删除',
									type: 'success'
								});
								this.$refs.table.update();
								this.updateTotal();
							}
						});
					}
				});
			},

			setPrice(item) {
				this.isCustom = item.is_custom;
				this._setPriceId = item.product_id;
				this.$refs.priceEdit.open();
				this.$refs.priceTable.load({
					url: '/product/get_sku',
					data: {
						product_id: item.product_id
					},
					dataFormatter: data => {
						data.forEach(item => {
							item.old_product_price_cost = item.product_price_cost;
						});
						return data;
					}
				});
				
				if(this.isCustom == 1) {
					this.$refs.customTable.load({
						url: '/product/custom/info',
						data: {
							product_id: item.product_id
						},
						dataFormatter: data => {
							var tableData = [];
							data.forEach(item => {
							if(item.list.length != 0) {
								tableData = tableData.concat(item.list);
							}
							});
							return tableData;
						}
					});
				}
			},
			
			setPriceHandle(stop) {
				stop();
				var vFlag = false;
				var product_sku_price_list = Array.from(this.$refs.priceTable.getRow(), item => {
					return {
						product_sku: item.data.product_sku,
						product_price: parseFloat(item.data.product_price_cost) || 0
					}
				});
				var product_custom_list = [];
				if( this.isCustom == 1){
					product_custom_list = Array.from(this.$refs.customTable.getRow(), item => {
						return {
							position_id: item.data.position_id,
							item_id: item.data.item_id,
							tech_id: item.data.tech_id,
							item_param_id: item.data.item_param_id,
							product_price: parseFloat(item.data.product_price_cost) || 0
							
						}
					})
				}
				
				// 获取所有行数据
				product_sku_price_list.forEach(item => {
					if(item.product_price == 0){
						vFlag = true;
					}
				});
				
				if(vFlag){
					this.$message({
						message: '存在未设置价格的规格服务'
					});
					return;
				}
				
				this.request({
					url: '/product/sku/price/edit',
					data: {
						product_id: this._setPriceId,
						product_sku_price_list: product_sku_price_list,
						product_custom_list: product_custom_list
					},
					loading: true,
					success: data => {
						this.$message({
							type: 'success',
							message: '价格设置成功'
						});
						this.$refs.priceEdit.close();
						this.$refs.table.update();
					}
				});
			},
			
			//单个服务多SKU调整普通设置售价
			batchSetPrice() {
				let n = parseFloat(this.$refs.batchPriceForm.get().value);
				if (n == n) {
					this.$refs.priceTable.getRow().forEach(item => {
						item.data.product_price_cost = n;
					})
				}
				this.$refs.batchPriceForm.clear();
			},
			
			//单个服务多SKU调整定制加价
			batchSetCustomPrice() {
				let n = parseFloat(this.$refs.batchCustomPriceForm.get().value);
				if (n == n) {
					this.$refs.customTable.getRow().forEach(item => {
						item.data.product_price_cost = n;
					})
				}
				this.$refs.batchCustomPriceForm.clear();
			},

			setStock(item) {
				this._setStockId = item.product_id;
				this.$refs.stockEdit.open();
				this.$refs.stockTable.load({
					url: '/product/get_sku',
					data: {
						product_id: item.product_id
					},
					dataFormatter: data => {
						data.forEach(item => {
							item.revise_stock = '';
						});
						return data;
					}
				});
			},
			
			setStockHandle(stop) {
				stop();
				this.request({
					url: '/product/set_sku_stock',
					data: {
						product_id: this._setStockId,
						product_sku_stock_list: Array.from(this.$refs.stockTable.getRow(), item => {
							return {
								product_sku: item.data.product_sku,
								product_total_count: parseInt(item.data.revise_stock) || 0
							}
						})
					},
					loading: true,
					success: data => {
						this.$message({
							type: 'success',
							message: '库存设置成功'
						});
						this.$refs.stockEdit.close();
						this.$refs.table.update();
					}
				});
			},
			
			previewHandle(data) {
				window.open(`${this.$store.state.systemConfig.pc_mall_url}item/${data.product_id}`);
			},
			
			batchSetStock() {
				let n = parseFloat(this.$refs.batchStockForm.get().value);
				if (n == n) {
					this.$refs.stockTable.getRow().forEach(item => {
						item.data.revise_stock = n;
					})
				}
				this.$refs.batchStockForm.clear();
			},
			//选货市场
			selectPlatformProduct(){
				this.platformProductData = {};
				this.$refs.platformProductSelector.open();
			},
			//复制选货市场服务至自己的平台
			copyPlatformProduct(da){
				this.platformProductData = da;
				this.$confirm({
					message: '确定要将选中的【'+this.platformProductData.length+'】款服务加入到商城吗？',
					resolve: () => {
						this.$refs.batchAddProductForm.clear();
						this.$refs.batchAddProductDialog.open();
					}
				});
			},
			//复制选货市场服务至自己的平台
			batchAddProduct(state){
				stop();
				this.$refs.batchAddProductForm.submit({
					url: '/platform/product/copy2seller',
					rule: {
						add_product_ratio: '请输入默认加价比例'
						// add_custom_money: '请输入定制加价金额'
					},
					dataFormatter: data => {
						data.product_ids = Array.from(this.platformProductData, item => {
							return item.product_id;
						});
                        data.add_custom_money = 0;
						data.state = state;
						return data;
					},
					success: (data, res) => {
						this.$refs.table.update();
						if(state == 1){
							this.$message({
								type: 'success',
								message: '铺货成功,请完善相关信息后进行上架'
							});
						}else{
							this.$message({
								type: 'success',
								message: '铺货成功!'
							});
						}
						this.$refs.platformProductSelector.close();
						this.$refs.batchAddProductDialog.close();
					}
				});
			},
			//开启或关闭自动同步
			configAutoSync(data){
				var is_auto_sync = data.is_auto_sync;
				this.$confirm({
					message: '是否确定要【'+(is_auto_sync==1?'关闭':'开启')+'】服务【'+data.product_name+'】自动同步？',
					resolve: () => {
						this.request({
							url: '/product/auto_sync/config',
							data: {
								product_id: data.product_id,
								is_auto_sync:(is_auto_sync==1?0:1)
							},
							loading: true,
							success: data => {
								this.$message({
									message:(is_auto_sync==1?'关闭':'开启')+'自动同步成功',
									type: 'success'
								});
								this.$refs.table.update();
								// this.updateTotal();
							}
						});
					}
				});
			},
			//手动执行服务数据同步
			syncProductData(data){
				this.$confirm({
					message: '是否确定要同步服务【'+data.product_name+'】数据？',
					resolve: () => {
						this.request({
							url: '/product/sync/retail',
							data: {
								product_id: data.product_id
							},
							loading: true,
							success: data => {
								this.$message({
									message:'同步请求已发送，请关注最近同步时间变化',
									type: 'success'
								});
								setTimeout(function(){
									this.$refs.table.update();
								}, 2000);
								// this.updateTotal();
							}
						});
					}
				});
			},

		}
	}
</script>

<style lang="stylus" scoped>
    .tip-text {
        border-radius: 5px;
        background-color: #0060ef;
        color: #E1CB57;
        opacity: 0.5;
        padding: 5px;
        width: 98%;
        height:15px;
    }
	.classify-select {
		padding: 10px;
		
		dl {
			width: 360px;
			border: 1px solid #ddd;
			
			&:nth-child(n+2) {
				border-left: none;
			}
			
			dt {
				position: relative;
				padding: 10px;
			
				.tf {
					position: absolute;
					width: 30px;
					line-height: 36px;
					font-size: 14px;
					text-align: center;
					color: #bbb;
				}
				
				input {
					box-sizing: border-box;
					width: 100%;
					height: 36px;
					border: none;
					padding: 0 10px 0 30px;
					background: #F5F5F5;
				}
			}
			
			dd {
				height: 290px;
				overflow: auto;
				
				li {
					padding: 0 14px;
					line-height: 36px;
					font-size: 13px;
					cursor: pointer;
					
					&:hover,
					&.z-crt {
						background: #FFF17E;
					}
				}
			}
		}
	}
</style>
